import { Radio } from '@tymbe/components/inputs/radio';
import classNames from 'classnames';
import { ComponentProps } from 'react';
import { textStyles } from '../../../style/text-styles';
import { TyRadio } from '../Radio';

type BadgePillVariant = 'default' | 'info' | 'success' | 'warning' | 'error';
type BadgePillSize = 'S' | 'M' | 'L';

const variantStyles: Record<BadgePillVariant, string> = {
  default: classNames(
    'bg-system-back-default',
    'text-system-back-default-significant',
    'has-[:checked]:bg-system-back-default-significant',
    'has-[:checked]:text-base-front-inverse'
  ),
  info: classNames(
    'bg-system-back-info',
    'text-system-back-info-significant',
    'has-[:checked]:bg-system-back-info-significant',
    'has-[:checked]:text-base-front-inverse'
  ),
  success: classNames(
    'bg-system-back-success',
    'text-system-back-success-significant',
    'has-[:checked]:bg-system-back-success-significant',
    'has-[:checked]:text-base-front-inverse'
  ),
  warning: classNames(
    'bg-system-back-warning',
    'text-system-back-warning-significant',
    'has-[:checked]:bg-system-back-warning-significant',
    'has-[:checked]:text-base-front-inverse'
  ),
  error: classNames(
    'bg-system-back-error',
    'text-system-back-error-significant',
    'has-[:checked]:bg-system-back-error-significant',
    'has-[:checked]:text-base-front-inverse'
  ),
};

const sizeStyles: Record<BadgePillSize, string> = {
  S: classNames(
    'px-2 rounded-full h-5',
    textStyles.pCaptionMd
  ),
  M: classNames(
    'px-2 rounded-md h-6',
    textStyles.pCaptionMd
  ),
  L: classNames(
    'px-2 py-1.5 rounded-md h-8',
    textStyles.pBody2Md
  ),
};

export type BadgePillRadioProps = {
  variant?: BadgePillVariant;
  sizeVariant?: BadgePillSize;
} & ComponentProps<typeof Radio>;

export const BadgePillRadio = ({
  variant,
  sizeVariant,
  className = '',
  ...props
}: BadgePillRadioProps) => {
  const style = variantStyles[variant ?? 'default'];
  const sizeStyle = sizeStyles[sizeVariant ?? 'M'];

  return (
    <TyRadio
      className={classNames(
        className,
        'flex gap-1 items-center mx-2 text-nowrap',
        '[&>input]:appearance-none',
        style,
        sizeStyle
      )}
      required={false}
      {...props}
    ></TyRadio>
  );
};
